import { useState } from 'react';
import Grid2 from '@thirdparty-framework/mui/material/Grid';
import {
  CRUDComponent,
  CRUD_COMPONENT_TYPE,
  FieldWrapperVertical,
  useDataProvider,
  useMasterData,
} from '@ui-framework/index';
import { Box, Stack } from '@mui/material';
import {
  id,
  dispatchId,
  serviceProviderId,
  serviceProviderName,
  status,
  serviceDate,
  acceptanceDate,
  rejectionDate,
  lastModifiedDateTime,
  createdDateTime,
  conditions,
  locationName,
  acceptedLocationName,
} from './accessorFunctions';
import listSchema from './list.json';
import DispatchEventStatus from '../../../../../DispatchEventStatus';

function DispatchAllStats({ stats, total, setStatus, currentStatus }) {
  const masterData = useMasterData();
  const { dispatchEvent } = masterData;
  const newDispatchEvents = [{ label: 'All', value: 'ALL' }, ...dispatchEvent];
  return (
    <Stack direction="row" justifyContent="right" spacing={1}>
      {newDispatchEvents.map(de => (
        <div key={de?.value}>
          <DispatchEventStatus
            onClick={() => setStatus(de?.value)}
            value={de?.value}
            count={de?.value === 'ALL' ? total : stats[de?.value] || 0}
            showCount
            selected={currentStatus === de?.value}
          />
        </div>
      ))}
    </Stack>
  );
}

function DispatchHistory({ serviceJob, dispatch }) {
  const provider =
    process.env.NODE_ENV === 'development' ? 'sxclServices' : 'default';
  const dataProvider = useDataProvider(provider);
  const { id: serviceJobId } = serviceJob;
  const [currentDispatchEeventStatus, setCurrentDispatchEeventStatus] =
    useState('PENDING_ACCEPTANCE');
  const [statusCount, setStatusCount] = useState({
    stats: {},
    total: 0,
  });

  let statusForApi = '';
  if (currentDispatchEeventStatus && currentDispatchEeventStatus !== 'ALL') {
    statusForApi = `status=${currentDispatchEeventStatus}`;
  }

  const listApiUrl = `${dataProvider.getApiUrl()}/sxcl/v1/service-jobs/${serviceJobId}/dispatches/${
    dispatch?.id
  }/events?${statusForApi}`;

  const listProps = {
    columnPrimaryId: 'id',
    storeName: 'DispatchHistory',
    dataProvider,
    schema: listSchema,
    initialState: {
      showColumnFilters: false,
    },
    downloadApiUrl: null,
    listApiUrl,
    accessorFunctions: {
      id,
      dispatchId,
      serviceProviderId,
      serviceProviderName,
      status,
      serviceDate,
      acceptanceDate,
      rejectionDate,
      lastModifiedDateTime,
      createdDateTime,
      conditions,
      locationName,
      acceptedLocationName,
    },
    sortOrder: 'DESC',
    sortBy: 'createdDateTime',
    onApiResponse: response => {
      if (response.ok) {
        const statusCountObj = { stats: {}, total: 0 };
        if (
          Array.isArray(response.data.stats) &&
          response.data.stats.length > 0
        ) {
          response.data.stats.forEach(item => {
            if (item.status && item.count !== undefined) {
              statusCountObj.stats[item.status] = Number(item.count);
              statusCountObj.total += Number(item.count);
            }
          });
        }
        setStatusCount(statusCountObj);
      }
    },
    enableColumnActions: false,
  };

  const progressSummaryField = {
    name: 'dispatch_progress_summary',
    label: {
      localeId: 'DISPATCH_PROGRESS_SUMMARY_HEADING',
      defaultMessage: 'Dispatch Progress Summary',
    },
    control: 'subsection',
  };

  return (
    <FieldWrapperVertical
      key={progressSummaryField?.name}
      field={progressSummaryField}
      errors={[]}>
      <Grid2 xs={12}>
        <Box sx={{ mb: 2 }}>
          <DispatchAllStats
            stats={statusCount?.stats || {}}
            total={statusCount?.total || 0}
            setStatus={setCurrentDispatchEeventStatus}
            currentStatus={currentDispatchEeventStatus}
          />
        </Box>
        <CRUDComponent
          key={currentDispatchEeventStatus}
          subSection
          type={CRUD_COMPONENT_TYPE.ADVANCED_LIST}
          listProps={listProps}
        />
      </Grid2>
    </FieldWrapperVertical>
  );
}

export default DispatchHistory;
